<template>
    <div class="tipo-ciclo-tarifa-form">
        <template>
            <div class="text-xs-center">
                <v-dialog v-model="showForm" width="400">
                    <v-card>
                        <v-toolbar card prominent color="primary" dark>
                            <v-toolbar-title class="body-2">{{ this.formTitle }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="cancelForm()">
                                <v-icon medium>fa-close</v-icon>
                            </v-btn>
                        </v-toolbar>

                        <v-card-text>
                            <v-form ref="tipoCicloTarifaForm" v-model="validTipoCicloTarifa">
                                <v-container fluid grid-list-xl>
                                    <v-layout align-center wrap>
                                        <v-flex xs12 sm12>
                                            <v-select
                                                v-model="tipoCicloTarifaItem.tipo_ciclo_id"
                                                :items="CICLO"
                                                label="Tipo de ciclo*"
                                                item-text="nombre"
                                                item-value="id"
                                                :rules="tipoCicloRules"
                                                :error-messages="tipoCicloErrors"
                                                @change="tipoCicloErrors = []"
                                                append-outer-icon="add"
                                                @click:append-outer="showTipoCicloForm = true"
                                            >
                                            </v-select>
                                        </v-flex>
                                        <v-flex xs12 sm12>
                                            <v-text-field
                                                v-model="tipoCicloTarifaItem.nombre_tarifa"
                                                label="Tarifa*"
                                                :rules="tarifaRules"
                                                :error-messages="tarifaErrors"
                                                @change="tarifaErrors = []"
                                                @keypress.enter.prevent="saveForm()"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" flat @click="cancelForm()" :disabled="loading">Cancelar</v-btn>
                            <v-btn
                                color="success"
                                flat
                                @click="saveForm()"
                                :disabled="disableSaveButton"
                                :loading="loading"
                                >Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>

        <ciclo-form
            v-if="showTipoCicloForm"
            form-title="Nuevo ciclo"
            :initial-item="null"
            @formCanceled="showTipoCicloForm = false"
        ></ciclo-form>
    </div>
</template>

<script>
const CicloForm = () => import("@/components/cobranza/nomencladores/ciclo-form/ciclo-form")
import { mapGetters } from "vuex"
export default {
    components: { CicloForm },
    props: {
        formTitle: { type: String, default: null },
        initialItem: { type: Object, default: null }
    },
    data() {
        return {
            loading: false,
            validTipoCicloTarifa: false,
            tipoCicloTarifaItem: {
                tipo_ciclo_id: "",
                nombre_tarifa: ""
            },
            tipoCicloRules: [v => !!v || "Debe proporcionar el tipo de ciclo"],
            tipoCicloErrors: [],
            tarifaRules: [v => !!v || "Debe proporcionar la tarifa"],
            tarifaErrors: [],

            //nomencladores
            showTipoCicloForm: false
        }
    },
    computed: {
        ...mapGetters(["CICLO"]),

        isNewRecord() {
            return this.initialItem === null
        },

        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        disableSaveButton() {
            return this.loading || !this.validTipoCicloTarifa
        }
    },

    methods: {
        saveForm() {
            this.loading = true
            this.$refs.tipoCicloTarifaForm.validate()
            if (this.validTipoCicloTarifa) {
                var tarifa = {
                    nombre: this.tipoCicloTarifaItem.nombre_tarifa,
                    tipo_ciclo_id: this.tipoCicloTarifaItem.tipo_ciclo_id
                }

                this.$store.dispatch("ADD_TARIFA", tarifa).then(result => {
                    if (!result) {
                        //no hay coneccion con el servidor
                        this.loading = false
                    }
                    if (result === null || result.status === 404) {
                        //cerrar el formulario si se inserto o actualizo bien (null) o cuando el elemento no existe
                        this.$emit("formCanceled")
                    } else {
                        // El backend devolvió error de validación, pasando los errores a los campos correspondientes
                        let { data, status } = result
                        if (status === 422) {
                            data.forEach(error => {
                                if (error.field === "nombre") {
                                    this.tarifaErrors.push(error.message)
                                }
                                if (error.field === "tipo_ciclo_id") {
                                    this.tipoCicloErrors.push(error.message)
                                }
                            })
                        }
                    }
                    this.loading = false
                })
            } else {
                this.loading = false
            }
        },
        cancelForm() {
            this.$emit("formCanceled")
        }
    },

    created() {
        this.$store.dispatch("LOAD_ALL_CICLO")
    }
}
</script>

<style scoped></style>
